// hooks/useLocalStorage.js
import { useEffect, useState } from 'react';

export function useLocalStorage(key, initialValue) {
  // État initial depuis localStorage ou la valeur par défaut
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.warn(`Erreur lecture localStorage pour ${key}`, error);
      return initialValue;
    }
  });

  // Sauvegarde dans localStorage à chaque modification
  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(storedValue));
    } catch (error) {
      console.warn(`Erreur écriture localStorage pour ${key}`, error);
    }
  }, [key, storedValue]);

  return [storedValue, setStoredValue];
}